import { PreloadedQuery } from 'react-relay';
import type { RouteResource } from '@townsquare/router/resources/types';

import { createRelayResource } from '@townsquare/relay-utils';

import OnboardingQuery, {
	type OnboardingQuery as OnboardingQueryType,
} from '../components/__generated__/OnboardingQuery.graphql';

export const onboardingResource: RouteResource<
	PreloadedQuery<OnboardingQueryType, Record<string, unknown>>
> = createRelayResource<OnboardingQueryType>({
	getQuery: () => {
		return {
			query: OnboardingQuery,
		};
	},
});
